import { SplitLayout } from "components/SplitLayout";
import { Box} from "@enaep-ng/benchmark";
import { ActionButtonRow, Title } from "lib/components";
import {ModeSelectionProps } from "Types/ViewTypes";

export const ModeSelectionView = (props: ModeSelectionProps) => {
  const { title, actions } = props;

  return (
    <SplitLayout>
      <Box>
        <Box
          sx={{
            '& [data-component="Heading"]': {
              color: "p.800",
              paddingBottom: "space-64",
            },
          }}
        >
          <Title content={title} style={{ fontWeight: "600" }} />
        </Box>
        <Box
          sx={{
            display: "flex",
          }}
        >
          <ActionButtonRow actionContainerStyle={{ marginLeft: "calc(8px * var(--zoom))" }} actions={actions} />
        </Box>
      </Box>
    </SplitLayout>
  );
};

